<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ 'users.history.table.activityDetails' | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-hidden px-6">
  <ng-container *ngIf="tables.length > 0 || userProfiles.length > 0; else noData">
    <div class="flex flex-col gap-8">
      <ng-container *ngFor="let table of tables; let i = index">
        <flow-history-table
          [title]="table.title"
          [columns]="table.columns"
          [data]="table.data">
        </flow-history-table>
      </ng-container>
      
      <div *ngIf="userProfiles.length > 0" class="w-full overflow-x-auto">
        <flow-permissions-history-table [userProfiles]="userProfiles"></flow-permissions-history-table>
      </div>
    </div>
  </ng-container>

  <ng-template #noData>
    <div class="text-center py-8">
      <p>{{ 'global.noDataFound' | translate }}</p>
    </div>
  </ng-template>
</mat-dialog-content>
